/** Legacy useApi request counters. Query activity comes directly from TanStack Query in useApiLoading. */
import React, { createContext, useState } from "react";

type ApiLoadingState = {
  [apiName: string]: number;
};

export const ApiLoadingStateContext = createContext<ApiLoadingState>({});
export const ApiLoadingSetStateContext = createContext<React.Dispatch<React.SetStateAction<ApiLoadingState>>>(() => undefined);

export const ApiLoadingProvider = ({ children }: { children: React.ReactNode }) => {
  const [loadingState, setLoadingState] = useState<ApiLoadingState>({});

  return (
    <ApiLoadingSetStateContext.Provider value={setLoadingState}>
      <ApiLoadingStateContext.Provider value={loadingState}>{children}</ApiLoadingStateContext.Provider>
    </ApiLoadingSetStateContext.Provider>
  );
};
